import { Store } from 'vuex'
import {
  setSendLogsToServer,
  setShowErrorLogs,
  setShowInfoLogs,
  setShowLogGroups,
  setShowLogLogs,
  setShowPerformanceLogs,
  setShowTimers,
  setShowWarnLogs,
} from '@/utils/logger'

export default function createLoggerPlugin(): (store: Store<any>) => void {
  return (store) => {
    store.subscribe((mutation, state) => {
      // console.group("store.subscribe");

      console.log('mutation.type: ', mutation.type)
      console.log('mutation.payload: ', mutation.payload)

      if (mutation.type === 'initialiseStore') {
        console.info('Initialising store')

        console.info(
          'Setting sendLogsToServer to ',
          state.settingsModule.sendLogsToServer,
        )
        console.info(
          'Setting showLogLogs to ',
          state.settingsModule.showLogLogs,
        )
        console.info(
          'Setting showInfoLogs to ',
          state.settingsModule.showInfoLogs,
        )
        console.info(
          'Setting showWarnLogs to ',
          state.settingsModule.showWarnLogs,
        )
        console.info(
          'Setting showErrorLogs to ',
          state.settingsModule.showErrorLogs,
        )
        console.info(
          'Setting showLogGroups to ',
          state.settingsModule.showLogGroups,
        )
        console.info('Setting showTimers to ', state.settingsModule.showTimers)
        console.info(
          'Setting showPerformanceLogs to ',
          state.settingsModule.showPerformanceLogs,
        )

        setSendLogsToServer(state.settingsModule.sendLogsToServer)
        setShowLogLogs(state.settingsModule.showLogLogs)
        setShowInfoLogs(state.settingsModule.showInfoLogs)
        setShowWarnLogs(state.settingsModule.showWarnLogs)
        setShowErrorLogs(state.settingsModule.showErrorLogs)
        setShowLogGroups(state.settingsModule.showLogGroups)
        setShowTimers(state.settingsModule.showTimers)
        setShowPerformanceLogs(state.settingsModule.showPerformanceLogs)
      } else if (mutation.type === 'setSendLogsToServer') {
        console.info('Setting sendLogsToServer to ', mutation.payload)
        setSendLogsToServer(mutation.payload)
      } else if (mutation.type === 'setShowLogLogs') {
        console.info('Setting showLogLogs to ', mutation.payload)
        setShowLogLogs(mutation.payload)
      } else if (mutation.type === 'setShowInfoLogs') {
        console.info('Setting showInfoLogs to ', mutation.payload)
        setShowInfoLogs(mutation.payload)
      } else if (mutation.type === 'setShowWarnLogs') {
        console.info('Setting showWarnLogs to ', mutation.payload)
        setShowWarnLogs(mutation.payload)
      } else if (mutation.type === 'setShowErrorLogs') {
        console.info('Setting showErrorLogs to ', mutation.payload)
        setShowErrorLogs(mutation.payload)
      } else if (mutation.type === 'setLogGroups') {
        console.info('Setting showLogGroups to ', mutation.payload)
        setShowLogGroups(mutation.payload)
      } else if (mutation.type === 'setShowTimers') {
        console.info('Setting showTimers to ', mutation.payload)
        setShowTimers(mutation.payload)
      } else if (mutation.type === 'setShowPerformanceLogs') {
        console.info('Setting showPerformanceLogs to ', mutation.payload)
        setShowPerformanceLogs(mutation.payload)
      }

      // console.groupEnd();
    })
  }
}
